<template>
  <div id="meeting">
    <div style="padding:10px;" ><h1 class="text-primary font-weight-bold my-4" style="text-align:center;">Town Hall Meetings</h1>
      <ul class="p-0" v-for="meeting in meetings" :key="meeting.id">
        <div class="p-3 text-muted"><p class="m-0">{{meeting.date}}</p><p class="m-0">{{meeting.time}}</p><p class="m-0"><b>{{meeting.location}}</b></p><p class="m-0">{{meeting.address}}</p><p class="m-0">{{meeting.zip}}</p><p class="m-0">{{meeting.note}}</p></div></ul>
</div>
    <footer-bar></footer-bar>
  </div>
</template>


<script>
import FooterBar from "@/components/FooterBar.vue";


export default {
  name: "Poll",
  components: { FooterBar },
  data() {
    return {
      meetings: [{
        id: "1",
        date: "Monday, October 17, 2022 ",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "Coral Reef Senior High ",
        address: "10101 S.W. 152 Street ",
          zip: "Miami, FL 33157 ", 
          note:""
        },
        {
        id: "2",
        date: "Tuesday, October 18, 2022 ",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "William H. Turner Technical Arts High ",
        address: "10151 N.W. 19 Avenue ",
          zip: "Miami, FL 33147",
          note:"* This town hall will be live streamed"
        },
        {
        id: "3",
        date: "Thursday, October 20, 2022",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "Miami Norland Senior High ",
        address: "1193 N.W. 193 Street ",
          zip: "Miami, FL 33169 ",
          note:""
        },
        {
        id: "4",
        date: "Monday, October 24, 2022",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "Booker T. Washington Senior High ",
        address: "1200 NW 6th Ave ",
          zip: "Miami, FL 33136 ",
          note:""
        },
        {
        id: "5",
        date: "Wednesday, October 26, 2022",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "North Miami Senior High",
        address: "13110 N.E. 8th Ave",
          zip: "Miami, FL 33161 ",
          note:""
        },
        {
        id: "6",
        date: "Thursday, October 27, 2022",
        time: "6:30 p.m. – 8:00 p.m.",
        location: "Miami Senior High",
        address: "2450 S.W. 1st Street",
          zip: "Miami, FL 33135 ",
          note:""
        },
        {
        id: "7",
        date: "Wednesday, November 2, 2022",
        time: "6:00 p.m. – 7:00 p.m.",
        location: "School Board Administration Building ",
        address: "1450 N.E. 2 Avenue ",
          zip: "Miami, FL 33132 ", 
          note: "*This town hall will be televised",
        },
      ],
    }
  }
};
</script>
